//@ts-nocheck
import BankAccount from '../../Inputs/BankAccount/BankAccount'
import Date from '../../Inputs/Date/Date'
import RadioGroup from '../../Inputs/RadioGroup/RadioGroup'
import Select from '../../Inputs/Select/Select'
import { DefaultString } from '../../Inputs/DefaultString/DefaultString'
import { Checkbox } from '../../Inputs/Checkbox/Checkbox'

import { StringVariants } from '../../Inputs/inputs.interface'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../module/rootStore'
import { IInputType } from '../../../interface/steps.interface'
import { IInputStatus } from '../../../interface/progress.interface'

import { useEffect, useRef, useMemo } from 'react'

interface Props {
  name: string
}
const InputComponents = ({ name }: Props) => {
  const {
    inputsData,
    values,
    currentStep,
    changeValues,
    checkChangeValue,
    apiErrors,
    firstErrorName,
    needsToScroll,
    setNeedsToScroll,
    isIbanCheckbox,
    changeIbanCheckbox
  } = useStore().StepsStore
  const { stepsProgress } = useStore().ProgressStore
  const { progressTrigger } = useStore().ProgressBar

  console.log({...apiErrors})

  const componentRef = useRef<any>(null)

  const status = stepsProgress[currentStep].inputs[name].status
  console.log(name, status, firstErrorName)
  useEffect(() => {
    if (
      (status === IInputStatus.error || status === IInputStatus.apiError) &&
      firstErrorName === name &&
      needsToScroll &&
      componentRef.current
    ) {
      componentRef.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })
      setNeedsToScroll(false)
    }
  }, [status, firstErrorName, name, needsToScroll, setNeedsToScroll])


console.log(name, inputsData[name])
  const settings = useMemo(() => {
    switch (inputsData[name].type) {
      case IInputType.string:
        return {
          ...inputsData[name],
          variant: StringVariants.default,
        }
      default:
        return inputsData[name]
    }
  }, [name])

  switch (inputsData[name].type) {
    case IInputType.select:
      return (
        <>
          {stepsProgress[currentStep].inputs[name].status !==
            IInputStatus.disabled && (
              <div ref={componentRef}>
                <Select
                  value={values[name]}
                  name={name}
                  status={status}
                  handleChange={changeValues}
                  settings={settings}
                />
              </div>
            )}
        </>
      )
    case IInputType.string:
      return (
        <div ref={componentRef}>
          <DefaultString
             value={values[name]}
             name={name}
             handleChange={changeValues}
             checkChangeValue={checkChangeValue}
             status={status}
             apiErrors={apiErrors}
             settings={settings}
             inputType={inputsData[name].inputType}
             progressTrigger={progressTrigger}
             tooltip={inputsData[name].tooltip}
          />
        </div>
      )
    case IInputType.bank:
      return (
        <div ref={componentRef}>
          <BankAccount
            value={values[name]}
            name={name}
            handleChange={changeValues}
            status={stepsProgress[currentStep].inputs[name].status}
            apiErrors={apiErrors}
            settings={settings}
            isIbanCheckbox={isIbanCheckbox}
            changeIbanCheckbox={changeIbanCheckbox}
            progressTrigger={progressTrigger}
            tooltip={inputsData[name].tooltip}
          />
        </div>
      )
    case IInputType.date:
      return (
        <div ref={componentRef}>
         <Date
            value={values[name]}
            name={name}
            handleChange={changeValues}
            status={stepsProgress[currentStep].inputs[name].status}
            apiErrors={apiErrors}
            settings={settings}
            progressTrigger={progressTrigger}
            checkChangeValue={checkChangeValue}
            tooltip={inputsData[name].tooltip}
          />
        </div>
      )
    case IInputType.radio:
      return (
        <div ref={componentRef}>
          <RadioGroup
            value={values[name]}
            name={name}
            status={status}
            handleChange={changeValues}
            settings={settings}
          />
        </div>
      )
    case IInputType.checkbox:
      return (
        <div ref={componentRef}>
          <Checkbox
            value={values[name]}
            status={status}
            name={name}
            handleChange={changeValues}
            settings={settings}
          />
        </div>
      )
    default:
      return <></>
  }
}

export default observer(InputComponents)
